export default __webpack_public_path__ + "static/media/mission-img.ea70d7ec.png";